var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c("CorpId"),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  staticClass: "flex-level",
                  on: { command: _vm.handleConfigForm },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "dropdown",
                        fn: function() {
                          return [
                            _c(
                              "el-dropdown-menu",
                              { staticClass: "flex-end" },
                              _vm._l(_vm.availablesWebhooks, function(hook) {
                                return _c(
                                  "el-dropdown-item",
                                  { key: hook.type, attrs: { command: hook } },
                                  [
                                    _vm._v(
                                      "\n                        Webhook " +
                                        _vm._s(hook.type) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3444654662
                  )
                },
                [
                  _c("CompassButton", {
                    staticClass: "flex-end",
                    attrs: {
                      label: _vm.$t.__("developerPage.Webhooks.create_webhook"),
                      type: "primary",
                      dropdown: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0" }, [
            _vm._v(
              _vm._s(
                _vm.$l10n.__(
                  "Les webhooks vous permettent de recevoir en temps réel les notifications d'activité de votre compte Sellsy dans une application tierce."
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$l10n.__("Ils permettent par exemple")) + ":\n        "
            ),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__(
                        "%(IlsPermettentParExemple)sDe recevoir les notifications textuelles de Sellsy dans le Slack de votre entreprise.",
                        { IlsPermettentParExemple: "" }
                      )
                    ) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$l10n.__(
                        "%(IlsPermettentParExemple)sD'envoyer les notifications au format JSON vers un autre système d'information et ainsi de savoir si l'application tierce a besoin d'appeler l'API de Sellsy pour effectuer une mise à jour.",
                        { IlsPermettentParExemple: "" }
                      )
                    ) +
                    "\n            "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://help.sellsy.com/hc/gestion-des-synchronisations/webhooks",
                  target: "_blank"
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Pour en savoir plus sur le fonctionnement des webhooks, vous pouvez consulter notre article de FAQ."
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", { attrs: { id: "faq-webhook-ip-address" } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-danger my-3" }, [
            _c("p", { staticClass: "mt-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Attention, les notifications envoyées via les Webhooks sont définies au niveau de votre compte et ne tiennent pas compte des privilèges de vos collaborateurs."
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Si vous décidez par exemple d'envoyer une notification Slack à chaque nouveau paiement, tous les collaborateurs présents sur le channel pourront la voir."
                    )
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-row mt-2" },
            [
              _c("paginator", {
                staticClass: "flex-item-right",
                attrs: { pagination: _vm.paginator },
                on: { "pagination:update": _vm.goToPage }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingTable,
                  expression: "loadingTable"
                }
              ],
              staticClass: "fixed-row-height wp-100 mt-2",
              attrs: {
                data: _vm.webhooks,
                border: "",
                "empty-text": _vm.$t.__(
                  "developerPage.Webhooks.no_webhook_configured"
                ),
                "default-sort": { prop: _vm.list[0].prop, order: "ascending" }
              }
            },
            [
              _vm._l(_vm.list, function(column, index) {
                return [
                  column.prop !== "status"
                    ? _c("el-table-column", {
                        key: index,
                        attrs: {
                          prop: column.prop,
                          label: column.label,
                          "show-overflow-tooltip": "",
                          sortable: "",
                          width: [index > 0 ? 150 : ""]
                        }
                      })
                    : _c("el-table-column", {
                        key: index,
                        attrs: { label: column.label, width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.is_enabled
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "webhook-status" },
                                          [
                                            _c(
                                              "CompassTag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  color: "green"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$l10n.__("Actif")
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : scope.row.is_enabled === false
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "webhook-status" },
                                          [
                                            _c(
                                              "CompassTag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  color: "gray"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$l10n.__("Désactivé")
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "webhook-status" },
                                          [
                                            _c(
                                              "CompassTag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  color: "gray"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$l10n.__(
                                                        "Non configuré"
                                                      )
                                                    ) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                ]
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  label: _vm.$t.__("common.labels.actions"),
                  width: "104"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "flex-row" },
                            [
                              _c(
                                "CompassTooltip",
                                {
                                  attrs: {
                                    placement: "bottom",
                                    content: _vm.$t.__(
                                      "developerPage.Webhooks.configuration_error"
                                    ),
                                    contentClass: "tooltip-btn-webhooks",
                                    disabled: !_vm.isWebhookNotEditable(
                                      scope.row
                                    )
                                  }
                                },
                                [
                                  _c("CompassIconButton", {
                                    attrs: {
                                      icon: "settings",
                                      type: "tertiary",
                                      disabled: _vm.isWebhookNotEditable(
                                        scope.row
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleConfigForm(scope.row)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "CompassTooltip",
                                {
                                  attrs: {
                                    content: _vm.$t.__(
                                      "developerPage.Webhooks.delete_webhook_error"
                                    ),
                                    placement: "bottom",
                                    contentClass: "tooltip-btn-webhooks",
                                    disabled: !_vm.isWebhookNotEditable(
                                      scope.row
                                    )
                                  }
                                },
                                [
                                  _c("CompassIconButton", {
                                    staticClass: "ml-2",
                                    attrs: {
                                      icon: "bin",
                                      type: "tertiary",
                                      disabled: _vm.isWebhookNotEditable(
                                        scope.row
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteWebhook(scope.row)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3407350032
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.openConfigForm
            ? _c("webhooks-modal", {
                staticClass: "webhook-modal",
                attrs: { visible: _vm.openConfigForm, config: _vm.configForm },
                on: { close: _vm.handleCloseConfigForm }
              })
            : _vm._e()
        ],
        1
      )
    : _c("preloader", { attrs: { background: false, display: true } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }